"use client";

import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";
import { CheckCircleIcon } from "lucide-react";
import { GridSvg } from "@/components/gridSvg";

export default function IndustrySolutions() {
  return (
    <section id={"industry-solutions"} className={"wrapper py-10 relative"}>
      <GridSvg />
      <div className={"flex flex-col gap-5 items-center text-center"}>
        <Badge>Industry Solutions</Badge>
        <h1 className={"text-4xl font-bold"}>
          Specialized Solutions for{" "}
          <span className={"text-primary"}>Every Industry</span>
        </h1>
        <p className={"text-muted-foreground text-lg font-semibold"}>
          Deep dive into our comprehensive offerings across seven key sectors,
          each tailored <br /> to meet specific industry requirements and
          challenges.
        </p>
        <div className={"flex flex-col gap-14 mt-5"}>
          {siteConfig.sectors.map((sector, index) => (
            <div
              key={index}
              className={"flex-1  text-start grid gap-10 lg:grid-cols-2"}
            >
              <div className={"flex flex-col gap-5"}>
                <div className={"flex gap-5"}>
                  <span
                    className={
                      "text-primary bg-primary/10 grid place-content-center p-5 rounded"
                    }
                  >
                    <sector.icon />
                  </span>
                  <span>
                    <h1 className={"text-2xl font-bold"}>{sector.title}</h1>
                    <h3 className={"text-muted-foreground font-semibold"}>
                      {sector.description}
                    </h3>
                  </span>
                </div>
                <div>
                  <h1 className={"text-lg font-bold"}>Key Features</h1>
                  <div className={"grid grid-cols-2 gap-5 mt-5"}>
                    {sector.features.map((feature, subIndex) => (
                      <span key={subIndex} className={"flex gap-2 items-start"}>
                        <CheckCircleIcon className={"text-primary"} />
                        <p>{feature}</p>
                      </span>
                    ))}
                  </div>
                </div>
                <div>
                  <h1 className={"text-lg font-bold"}>Benefits</h1>
                  <div className={"flex flex-wrap gap-2 mt-1"}>
                    {sector.benefits.map((benefit, subIndex) => (
                      <Badge
                        variant={"outline"}
                        key={subIndex}
                        className={"flex gap-2 items-start"}
                      >
                        <p>{benefit}</p>
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
              <div
                className={`flex flex-col py-5 justify-center row-end-1 lg:row-end-auto items-center gap-2 bg-primary/10 text-center ${index % 2 === 0 ? "" : "lg:row-start-1"}`}
              >
                <span className={"p-10 rounded bg-primary/90 text-white"}>
                  {" "}
                  <sector.icon className={"size-5 lg:size-10"} />
                </span>
                <h1 className={"text-xl lg:text-2xl font-bold"}>
                  {sector.title}
                </h1>
                <p
                  className={"text-muted-foreground lg:text-base text-sm w-1/2"}
                >
                  {sector.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
